import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Guid } from 'src/app/models/Guid.model';
import { PartnerRecommendation } from 'src/app/models/Partner/PartnerRecommendation';
import { Observable, from, map, of, switchMap } from 'rxjs';
import { AlertMessageService } from '../alert-message/alert-message.service';
import { RequestResultStatusCodeEnum } from 'src/app/Enums/RequestResultStatusCodeEnum';
import { RecommendationStatusEnum } from 'src/app/Enums/RecommendationStatusEnum';
import { PartnerRecommendationCommand } from 'src/app/models/Partner/PartnerRecommendationCommand';
import { unmaskCnpj } from 'src/validators/cnpj/cnpj';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  constructor(
    private api: ApiService,
    private alertService: AlertMessageService,
    private translate: TranslateService,
  ) {}

  private handleError(response: any) {
    switch (response.statusCode) {
      case RequestResultStatusCodeEnum.InternalServerError:
        this.alertService.alertErrorMessage(response.message!);
        return throwError(() => new Error(response.message));
      case RequestResultStatusCodeEnum.NotFound:
        this.alertService.alertWarningMessage(response.message!);
        return throwError(() => new Error(response.message));
      case RequestResultStatusCodeEnum.Conflict:
        this.alertService.alertWarningMessage(response.message!);
        return throwError(() => new Error(response.message));
      default:
        this.alertService.alertErrorMessage(
          this.translate.instant('api.internalServerError'),
        );
        return throwError(() => new Error(response.message));
    }
  }
  verifyCodePartner(codigo: string, usuario: any): Observable<any> {
    localStorage.setItem('usuarioParceiro', JSON.stringify(usuario));
    return from(
      this.api.get('/v1/partner/code?partnerCode=' + codigo),
    ).pipe(
      switchMap((response) => {
        const data: any = response.data;
        if (response.statusCode !== 200) {
          throw this.handleError(response);
        }

        const usuarioLocalStorage = JSON.parse(localStorage.getItem('usuarioParceiro') || '{}');
        const payload: PartnerRecommendationCommand = {
          PartnerSellerId: data.partnerSellerId,
          CompanyName: usuarioLocalStorage.fullName,
          PhoneNumber: usuarioLocalStorage.phone,
          RecommendationStatus: RecommendationStatusEnum.Ativo,
          Document: unmaskCnpj(usuarioLocalStorage.document),
          Email: usuarioLocalStorage.email,
          DialCode: usuarioLocalStorage.dialCode,
          UsedReferralCode: codigo,
        };
        return this.linkPartnerCodeToUser(payload);
      }),
    );
  }

  validateReferralCodeOnly(codigo: string): Observable<any> {
    return from(
      this.api.get('/v1/partner/code?partnerCode=' + codigo),
    ).pipe(
      map((response) => {
        if (response.statusCode !== 200) {
          throw this.handleError(response);
        }
        return response.data;
      }),
    );
  }

  linkPartnerCodeToUserByData(codigo: string, partnerSellerId: string, usuario: any): Observable<any> {
    const payload: PartnerRecommendationCommand = {
      PartnerSellerId: partnerSellerId,
      CompanyName: usuario.fullName,
      PhoneNumber: usuario.phone,
      RecommendationStatus: RecommendationStatusEnum.Ativo,
      Document: unmaskCnpj(usuario.document),
      Email: usuario.email,
      DialCode: usuario.dialCode,
      UsedReferralCode: codigo,
    };
    return this.linkPartnerCodeToUser(payload);
  }

  linkPartnerCodeToUser(payload: any): Observable<any> {
    return from(
      this.api.post('/partner/v1/recommendation/register', payload),
    ).pipe(
      map((response) => {
        if (response.statusCode !== 201) {
          throw this.handleError(response);
        }
        localStorage.removeItem('usuarioParceiro');
        return response.data;
      }),
    );
  }

  public getPartnerRecommendationByGuid(partnerGuid: Guid): Observable<PartnerRecommendation | null> {

    if (!new Guid().isValid(partnerGuid.toString())) {
      this.alertService.alertErrorMessage("Link da indicação é inválido. Verifique!")
      return of(null);
    }

    return from(this.api.get<PartnerRecommendation>('/v1/partner/recommendation/' + partnerGuid))
      .pipe(
        map((response) => {
          if (response.statusCode == RequestResultStatusCodeEnum.InternalServerError) {
            this.alertService.alertErrorMessage(response.message!)
            return null;
          }
          else if (response.messageCode == RequestResultStatusCodeEnum.NotFound) {
            this.alertService.alertWarningMessage(response.message!)
            return null;
          }
          else if (response.messageCode == RequestResultStatusCodeEnum.Conflict) {
            this.alertService.alertWarningMessage(response.message!)
            return null;
          }
          //this.alertService.alertSuccessMessage(response.message!) NAO TERÁ MENSAGEM?
          return response.data as PartnerRecommendation;
        }),
      )
  }
}
